import { useCallback, useState } from 'react';

import { Typography } from '@mui/material';
import { useAppDispatch,useAppSelector } from 'app/hooks';
import { DeleteDialog } from 'common/components/deleteDialog/DeleteDialog';
import { setDialogOpen } from 'common/components/deleteDialog/deleteDialogSlice';
import { selectPageInfo, setRows } from 'common/components/PalmDataGrid/palmDataGridSlice';
import { extractStatusCode } from 'common/services/api/apiHelpers';
import { deleteTenant } from 'common/services/api/Tenants/Tenants.thunks';
import {
    DeleteDialogContentProps
} from 'common/types/TypeDefs';
import { handleDeleteDialogError } from 'common/utils/errorHandlers';
import { useSnackbar } from 'notistack';

export const TenantsDeleteDialogContent = ({
    title,
    itemId,
    editingRow,
}: DeleteDialogContentProps<{ name: string }>) => {
    const { name } = editingRow ?? {};
    const dispatch = useAppDispatch();
    const appSuite = useAppSelector(selectPageInfo) ?? { id: '', name: '' };

    const [processing, setProcessing] = useState<boolean>(false);

    const { enqueueSnackbar } = useSnackbar();

    const successHandler = (): void => {
        dispatch(setDialogOpen(false));
        enqueueSnackbar('Tenant has been deleted.', { variant: 'success' });
    };

    const tenantDeleteCallback = useCallback(() => {
        if (itemId) {
            setProcessing(true);
            dispatch(deleteTenant({ id: itemId.toString(), suiteId: appSuite.id }))
                .unwrap()
                .then((result) => {
                    dispatch(setRows(result.rows));
                    successHandler();
                    setProcessing(false);
                })
                .catch((error) => {
                    handleDeleteDialogError('Tenant', enqueueSnackbar, extractStatusCode(error.message));
                    setProcessing(false);
                });
        }
    }, [itemId]);

    return  (
        <DeleteDialog deleteCallback={tenantDeleteCallback} title={title} processing={processing ?? false}>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                Tenant Name: <Typography component="span" color="text.primary" fontWeight="400">{name}</Typography>
            </Typography>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                Tenant ID: <Typography component="span" color="text.primary" fontWeight="400">{itemId}</Typography>
            </Typography>
            <Typography color="info.light" fontSize='0.9rem' fontWeight='550'>
                Application Suite Name: <Typography component="span" color="text.primary" fontWeight="400">{appSuite.name}</Typography>
            </Typography>
        </DeleteDialog>
    );
};
